export const PATH_NAME_CONFERENCE_MAIN = 'conference'
export const PATH_NAME_CONFERENCE_AUTH_FROM_CODE = 'conference_auth_from_code'
export const PATH_NAME_CONFERENCE_LIVE_VIEW = 'conference_live_view'
